document.addEventListener('DOMContentLoaded', function () {
  var filtersContainer = document.getElementById('child-filters');
  var childrenList = document.getElementById('children-list');
  var emptyMsg = document.getElementById('children-empty');

  if (!filtersContainer || !childrenList) return;

  var activeFilters = {};

  filtersContainer.addEventListener('click', function (e) {
    var btn = e.target.closest('.child-filter__btn');
    if (!btn) return;

    var filterGroup = btn.closest('.child-filter');
    var filterKey = filterGroup.dataset.filter;
    var value = btn.dataset.value;

    filterGroup.querySelectorAll('.child-filter__btn').forEach(function (b) {
      b.classList.remove('is-active');
    });
    btn.classList.add('is-active');

    if (value === 'all') {
      delete activeFilters[filterKey];
    } else {
      activeFilters[filterKey] = value;
    }

    applyFilters();
  });

  function applyFilters() {
    var rows = childrenList.querySelectorAll('.child-row');
    var visibleCount = 0;

    rows.forEach(function (row) {
      var show = true;

      for (var key in activeFilters) {
        if (row.dataset[key] !== activeFilters[key]) {
          show = false;
          break;
        }
      }

      row.style.display = show ? '' : 'none';
      if (show) visibleCount++;
    });

    if (emptyMsg) {
      emptyMsg.style.display = visibleCount === 0 ? '' : 'none';
    }
  }
});
